import React, { useEffect } from "react";
import CustomTextField from "../../../../../components/widgets/CustomTextField";
import {
  circumferentialStress,
  inputData,
  LongitudinalBending,
  TangentialShear,
} from "./inputFields/saddleInputFormat";

import "@fontsource/roboto/300.css";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import { useFormContext } from "react-hook-form";
const GridStyle = {
  "&.MuiGrid-item": { p: "3px 0px 0px 5px" },
};

const subHeadingStyle = {
  color: "#4e5fa2",
  fontWeight: "bold",
  mb: "5px",
};

const typographySize = {
  fontSize: "0.8rem",
};

const SaddleAnalysisTab = (props) => {
  const { calculationResult } = props;
  const { getValues, setValue, watch } = useFormContext();

  const englishUnits = watch("engUnits");

  const getInputUnit = (input) =>
    englishUnits ? input.englishInputProps || input.inputProps : input.inputProps;

  useEffect(() => {
    const allValues = getValues();
    let headComponent = allValues?.DataGridView5?.find((value) =>
      value?.Component?.includes("Head")
    );
    let shellComponent = allValues?.DataGridView5?.find((value) =>
      value?.Component?.includes("Shell")
    );

    // Auto-populate from Design tab
    if (allValues.shellStress) setValue("txt_AS_SC", allValues.shellStress);

    // Auto-populate from Shell tab
    const shellDia = shellComponent?.Diameter || allValues.vesselDiameter || "";
    const shellThk = shellComponent?.["Provided Thk"] || "";
    const shellLen = shellComponent?.["Can Length"] || "";
    if (shellDia) setValue("txt_R_SC", parseFloat(shellDia) / 2);
    if (shellLen) setValue("txt_LS_SC", shellLen);
    if (shellThk) setValue("txt_TS_SC", shellThk);

    // Auto-populate from Head tab
    if (headComponent?.["Can Length"]) setValue("txt_LH_SC", headComponent["Can Length"]);
    if (headComponent?.["Provided Thk"]) setValue("txt_TH_SC", headComponent["Provided Thk"]);

    // Defaults for user fields (only if empty)
    if (allValues.txt_Q_SC == null) {
      const steelDensity = 7.85e-6;
      const diaNum = parseFloat(shellDia) || 0;
      const thkNum = parseFloat(shellThk) || 0;
      const shellLenNum = parseFloat(shellLen) || 0;
      const headThkNum = parseFloat(headComponent?.["Provided Thk"] || shellThk) || 0;
      const shellWeight = Math.PI * (diaNum + thkNum) * shellLenNum * thkNum * steelDensity;
      const headWeight = 1.084 * diaNum * diaNum * headThkNum * steelDensity;
      const estWeight = shellWeight + 2 * headWeight;
      setValue("txt_Q_SC", Math.round(estWeight / 2));
    }
    if (allValues.txt_CA_SC == null) setValue("txt_CA_SC", 120);
    if (!allValues.txt_SD_SC && shellLen) setValue("txt_SD_SC", parseFloat(shellLen) / 4);
  }, []);

  console.log("calculationResults - Nozzle:", calculationResult);
  return (
    <div
      width="100%"
      style={{
        "&. MuiTypography-root": {
          color: "red",
        },
        fontSize: "0.775rem",
      }}
    >
      {/* <br /> */}
      <Typography sx={{ ...subHeadingStyle }}>Input Data</Typography>
      {/* <br /> */}

      {/* Input data */}
      <Grid
        container
        sx={{ alignItems: "center" }}
        columns={{ xs: 12, lg: 11, xl: 12 }}
      >
        {inputData.map((input) => {
          const isUser = input.isUserField;
          const userColor = "#d97706";
          return (
            <Grid key={input.label} container item>
              <Grid item sx={{ ...GridStyle }} xs={4} lg={3}>
                <Typography {...typographySize} sx={isUser ? { color: userColor } : {}}>{input.label}</Typography>
              </Grid>
              <Grid item sx={{ ...GridStyle }} xs={true}>
                <Typography
                  textAlign="right"
                  sx={{ fontWeight: "100", fontSize: "0.75rem", color: isUser ? userColor : undefined }}
                >
                  {input.variable}
                </Typography>
              </Grid>
              <Grid item sx={{ ...GridStyle }} xs={3} lg={2}>
                <CustomTextField
                  hiddenLabel={true}
                  id={input.txtFieldName}
                  name={input.txtFieldName}
                  type={input.type}
                  required={true}
                  pairField={input.pairField || null}
                  inputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {getInputUnit(input)}
                      </InputAdornment>
                    ),
                    style: isUser ? { color: userColor } : {},
                  }}
                />
              </Grid>
              <Grid item sx={{ ...GridStyle }} xs={4}></Grid>
            </Grid>
          );
        })}
      </Grid>

      {/* LongitudinalBending */}
      <br />
      <Typography sx={{ ...subHeadingStyle }}>Longitudinal Bending</Typography>
      <Grid
        container
        sx={{ alignItems: "center" }}
        columns={{ xs: 12, lg: 12, xl: 12 }}
      >
        {LongitudinalBending.map((input) => {
          return (
            <Grid container item>
              <Grid item sx={{ ...GridStyle }} xs={12} lg={12}>
                <Typography>{input.label}</Typography>
              </Grid>
              <Grid item sx={{ ...GridStyle }} xs={1} lg={1}>
                <Typography textAlign="right">{input.variable}</Typography>
              </Grid>
              <Grid item sx={{ ...GridStyle }} xs={true}>
                {/* <Grid item sx={{ ...GridStyle }}> */}
                <span
                  class="Fraction"
                  style={{
                    display: "table-cell",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <span class="Numerator">{input?.numerator}</span>
                  <span
                    class="Denominator"
                    style={{ borderTop: "1px solid #000", display: "block" }}
                  >
                    {input?.denominator}
                  </span>
                </span>
                {/* <Typography style={{ whiteSpace: 'pre-wrap', lineHeight: "0.7rem", textAlign: "center" }}>{input.formula}</Typography> */}
              </Grid>
              <Grid item sx={{ ...GridStyle }} xs={0.5} lg={0.5}>
                <Typography textAlign="right">=</Typography>
              </Grid>
              <Grid item sx={{ ...GridStyle }} xs={3} lg={2}>
                <CustomTextField
                  hiddenLabel={true}
                  id={input.txtFieldName}
                  name={input.txtFieldName}
                  type={input.type}
                  // required={input.required}
                  disabled={input.disabled || false}
                  pairField={input.pairField || null}
                  inputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {getInputUnit(input)}
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ ...GridStyle }} xs={4}></Grid>
            </Grid>
          );
        })}
      </Grid>

      {/* TangentialShear */}
      <br />
      <Typography sx={{ ...subHeadingStyle }}>Tangential Shear</Typography>
      <Grid
        container
        sx={{ alignItems: "center" }}
        columns={{ xs: 12, lg: 12, xl: 12 }}
      >
        {TangentialShear.map((input) => {
          return (
            <Grid container item>
              <Grid
                item
                sx={{
                  ...GridStyle,
                  marginBottom: "1rem",
                  marginTop: "0.2rem",
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
                xs={12}
                lg={12}
              >
                <Typography>{input.label}</Typography>
              </Grid>
              <br></br>
              <Grid item sx={{ ...GridStyle }} xs={1} lg={1}>
                <Typography textAlign="right">{input.variable}</Typography>
              </Grid>
              <Grid item sx={{ ...GridStyle }} xs={true}>
                {/* <Grid item sx={{ ...GridStyle }}> */}
                <span
                  class="Fraction"
                  style={{ display: "table-cell", textAlign: "center" }}
                >
                  <span class="Numerator">{input?.numerator}</span>
                  <span
                    class="Denominator"
                    style={{ borderTop: "1px solid #000", display: "block" }}
                  >
                    {input?.denominator}
                  </span>
                </span>
                {/* <Typography style={{ whiteSpace: 'pre-wrap', lineHeight: "0.8rem", textAlign: "center" }}>{input.formula}</Typography> */}
              </Grid>
              <Grid item sx={{ ...GridStyle }} xs={1} lg={1}>
                <Typography textAlign="right">=</Typography>
              </Grid>
              <Grid item sx={{ ...GridStyle }} xs={3} lg={2}>
                <CustomTextField
                  hiddenLabel={true}
                  id={input.txtFieldName}
                  name={input.txtFieldName}
                  type={input.type}
                  // required={input.required}
                  disabled={input.disabled || false}
                  pairField={input.pairField || null}
                  inputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {getInputUnit(input)}
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ ...GridStyle }} xs={4}></Grid>
            </Grid>
          );
        })}
      </Grid>

      {/* Circumferential Stess */}
      <br />
      <Typography sx={{ ...subHeadingStyle }}>Circumferential Stess</Typography>
      <Grid
        container
        sx={{ alignItems: "center" }}
        columns={{ xs: 12, lg: 12, xl: 12 }}
      >
        {circumferentialStress.map((input) => {
          return (
            <Grid container item>
              <Grid
                item
                sx={{
                  ...GridStyle,
                  marginBottom: "1rem",
                  marginTop: "0.2rem",
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
                xs={12}
                lg={12}
              >
                <Typography>{input.label}</Typography>
              </Grid>
              <br></br>
              <Grid item sx={{ ...GridStyle }} xs={1} lg={1}>
                <Typography textAlign="right">{input.variable}</Typography>
              </Grid>
              <Grid item sx={{ ...GridStyle }} xs={true}>
                {/* <Grid item sx={{ ...GridStyle }}> */}
                <span
                  class="Fraction"
                  style={{ display: "table-cell", textAlign: "center" }}
                >
                  <span class="Numerator">{input?.numerator1}</span>
                  <span
                    class="Denominator"
                    style={{ borderTop: "1px solid #000", display: "block" }}
                  >
                    {input?.denominator1}
                  </span>
                </span>
                {/* <Typography style={{ whiteSpace: 'pre-wrap', lineHeight: "0.8rem", textAlign: "center" }}>{input.formula}</Typography> */}
              </Grid>
              <Grid item>_&emsp;</Grid>
              {/* <Grid item sx={{ ...GridStyle }} xs={0.5} lg={0.5}>
                                    <Typography textAlign="right">=</Typography>
                                </Grid> */}

              <Grid item sx={{ ...GridStyle }} xs={true}>
                {/* <Grid item sx={{ ...GridStyle }}> */}
                <span
                  class="Fraction"
                  style={{
                    display: "table-cell",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <span class="Numerator">{input?.numerator2}</span>
                  <span
                    class="Denominator"
                    style={{
                      borderTop: "1px solid #000",
                      display: "block",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {input?.denominator2}
                  </span>
                </span>
                {/* <Typography style={{ whiteSpace: 'pre-wrap', lineHeight: "0.8rem", textAlign: "center" }}>{input.formula2}</Typography> */}
              </Grid>
              <Grid item sx={{ ...GridStyle }} xs={0.5} lg={0.5}>
                <Typography textAlign="right">=</Typography>
              </Grid>
              <Grid item sx={{ ...GridStyle }} xs={3} lg={2}>
                <CustomTextField
                  hiddenLabel={true}
                  id={input.txtFieldName}
                  name={input.txtFieldName}
                  type={input.type}
                  // required={input.required}
                  disabled={input.disabled || false}
                  pairField={input.pairField || null}
                  inputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {getInputUnit(input)}
                      </InputAdornment>
                    ),
                    style: {
                      fontSize: "0.875rem",
                      height: "20px",
                      backgroundColor: input.disabled ? "action.hover" : "background.paper",
                      color: input.disabled ? "text.primary" : "text.primary",
                    },
                  }}
                />
              </Grid>
              <Grid item sx={{ ...GridStyle }} xs={4}></Grid>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};

export default SaddleAnalysisTab;
